export class FUIBreakpoint {
    public minWidth?: number;
    public maxWidth?: number;
    public minHeight?: number;
    public maxHeight?: number;
    public title: string;

    constructor(breakpoint: any) {
        this.minWidth = breakpoint && breakpoint.minWidth || 0;
        this.maxWidth = breakpoint && breakpoint.maxWidth || Number.MAX_SAFE_INTEGER;
        this.minHeight = breakpoint && breakpoint.minHeight || 0;
        this.maxHeight = breakpoint && breakpoint.maxHeight || Number.MAX_SAFE_INTEGER;
        this.title = breakpoint && breakpoint.title || null;
    }

    appliesAt(width: number, height: number): boolean {
        return width >= this.minWidth && width <= this.maxWidth && height >= this.minHeight && height <= this.maxHeight;
    }
}
